import React from "react";

function Footer() {
  return (
    <footer className="footer">
      <p>🎬 Movie Manager App | Designed by Noorae Jasmi</p>
      <p>&copy; {new Date().getFullYear()} All Rights Reserved</p>
    
    </footer>
  );
}

export default Footer;